import React, { useCallback, useEffect } from 'react'
import { FaChevronLeft } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import { useFormik } from "formik"
import * as Yup from "yup"
import { request } from "../../services/request"
import { Form } from 'react-bootstrap'
import PrimaryButton from '../../components/subComponents/PrimaryButton'
import { EnforcementData } from '../../services/authinterface'

const AddOrUpdateLawEnforcement = () => {
    const Icon: any = FaChevronLeft
    const param = useParams()
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false)
    const [lawEnforcementData, setLawEnforcementData] = React.useState<EnforcementData | null>(null)
    const validationSchema = Yup.object().shape({
        domain: Yup.string().required("Please enter Domain"),
        department_name: Yup.string().required("Please enter Department Name"),
        city: Yup.string().required("Please enter City"),
        state: Yup.string().required("Please enter State"),
        // confidence_score: Yup.number().required("Please enter Confidence Score"),
    })

    const navigate = useNavigate()

    const formik = useFormik({
        initialValues: {
            domain: lawEnforcementData?.domain || "",
            department_name: lawEnforcementData?.department_name || "",
            city: lawEnforcementData?.city || "",
            state: lawEnforcementData?.state || "",
            // confidence_score: lawEnforcementData?.confidence_score || 0
        },
        validationSchema,
        onSubmit: async (values) => {
            setIsSubmitting(true)
            try {
                const payload = {
                    domain: values.domain,
                    department_name: values.department_name,
                    city: values.city,
                    state: values.state,
                    ...(param.id && {id: param.id})
                    // confidence_score: values.confidence_score,
                }
                const response = await request({
                    url: `/adminCommon/createOrUpdateLawEnforcementDomain`,
                    method: "POST",
                    data: payload,
                })
                if (response.data) {
                    toast.success(response.message)
                    formik.resetForm()
                    navigate(`/law-enforcement-domain`)

                } else {
                    toast.error(response.message)
                }
            } catch (error: any) {
                toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
            } finally {
                setIsSubmitting(false)
            }
        },
    })

    const { setFieldValue } = formik

    const fetchLawEnforcement = useCallback(async () => {
        try {

            const response = await request<any>({
                url: `/adminCommon/listEnforsementDomains/${param.id}`,
                method: "GET",
            })

            if (response.data) {
                setLawEnforcementData(response.data[0])
            } else {
                toast.error("Failed to Get Law Enforcement Data: " + response.message)
            }
        } catch (error) {
            console.log(error)
        }
    }, [param.id])

    useEffect(() => {
        if (!lawEnforcementData) return
        setFieldValue("domain", lawEnforcementData.domain)
        setFieldValue("department_name", lawEnforcementData.department_name)
        setFieldValue("city", lawEnforcementData.city)
        setFieldValue("state", lawEnforcementData.state)
    }, [lawEnforcementData, setFieldValue])

    useEffect(() => {
        if(param.id){
            fetchLawEnforcement()
        }
    }, [fetchLawEnforcement, param.id])

    const getBack = () => {
        navigate(-1)
    }

    return (
        <section className='dashboard-section'>
            <ToastContainer position='top-right' autoClose={2000} theme='light' />

            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        <div className='d-flex gap-1 customer-detail-line'>
                            <button onClick={getBack} className='d-flex align-items-center'>
                                <Icon size={20} />
                            </button>
                            <div className='dashboard-table-title-section'>
                                <h2>{param.id ? "Edit" : "Add"} Law Enforcement Domain</h2>
                            </div>
                        </div>
                    </div>
                    <div className='col-xl-8 col-lg-10 col-md-10 col-12 mt-4'>
                        <div>
                            <form onSubmit={formik.handleSubmit} className='customer-edit-form'>
                                <div className='login-input-section'>
                                    <label htmlFor='domain'>Domain*</label>
                                    <Form.Control
                                        type='text'
                                        name='domain'
                                        id='domain'
                                        placeholder='Please enter Domain'
                                        value={formik.values.domain}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        min={1}
                                        isInvalid={!!(formik.touched.domain && formik.errors.domain)}
                                    />
                                    <span className='text-red-500 text-xs'>
                                        {formik.touched.domain && typeof formik.errors.domain === "string"
                                            ? formik.errors.domain
                                            : null}
                                    </span>
                                </div>
                                <div className='login-input-section'>
                                    <label htmlFor='department_name'>Department Name*</label>
                                    <Form.Control
                                        type='text'
                                        name='department_name'
                                        id='department_name'
                                        placeholder='Please enter Department Name'
                                        value={formik.values.department_name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!(formik.touched.department_name && formik.errors.department_name)}
                                    />
                                    <span className='text-red-500 text-xs'>
                                        {formik.touched.department_name && typeof formik.errors.department_name === "string"
                                            ? formik.errors.department_name
                                            : null}
                                    </span>
                                </div>
                                <div className='login-input-section'>
                                    <label htmlFor='city'>City*</label>
                                    <Form.Control
                                        type='text'
                                        name='city'
                                        id='city'
                                        placeholder='Please enter City'
                                        value={formik.values.city}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!(formik.touched.city && formik.errors.city)}
                                    />
                                    <span className='text-red-500 text-xs'>
                                        {formik.touched.city && typeof formik.errors.city === "string"
                                            ? formik.errors.city
                                            : null}
                                    </span>
                                </div>
                                <div className='login-input-section'>
                                    <label htmlFor='state'>State*</label>
                                    <Form.Control
                                        type='text'
                                        name='state'
                                        id='state'
                                        placeholder='Please enter state'
                                        value={formik.values.state}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!(formik.touched.state && formik.errors.state)}
                                    />
                                    <span className='text-red-500 text-xs'>
                                        {formik.touched.state && typeof formik.errors.state === "string"
                                            ? formik.errors.state
                                            : null}
                                    </span>
                                </div>
                                {/* <div className='login-input-section'>
                                    <label htmlFor='state'>Confidence Score*</label>
                                    <Form.Control
                                        type='number'
                                        name='confidence_score'
                                        id='confidence_score'
                                        placeholder='Please enter Confidence Score'
                                        value={formik.values.confidence_score}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        isInvalid={!!(formik.touched.confidence_score && formik.errors.confidence_score)}
                                    />
                                    <span className='text-red-500 text-xs'>
                                        {formik.touched.confidence_score && typeof formik.errors.confidence_score === "string"
                                            ? formik.errors.confidence_score
                                            : null}
                                    </span>
                                </div> */}
                                <PrimaryButton disabled={isSubmitting} type='submit' label={isSubmitting ? (param.id ? "Updating..." : "Creating...") : (param.id ? "Update" : 'Create' )} className={`editFormButton mx-0 mt-3 w-fit ${isSubmitting ? "cursor-not-allowed" : ""}`} />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddOrUpdateLawEnforcement
